const providerAliases = {
    netflix: ['provider:netflix'],
    disney: ['provider:disney+', 'provider:disney plus'],
    hbo: ['provider:hbo max', 'provider:max'],
    prime: ['provider:prime video', 'provider:amazon prime video'],
    hulu: ['provider:hulu'],
    paramount: ['provider:paramount+', 'provider:paramount plus'],
    peacock: ['provider:peacock'],
    crunchyroll: ['provider:crunchyroll'],
    appletv: ['provider:apple tv+', 'provider:apple tv', 'provider:apple tv plus'],
    magellan: ['provider:magellantv', 'provider:magellan tv'],
};

const curated = [
    { slug: 'tmdb-top-rated-movies', name: 'Top Rated Movies', collectionId: 'f68bbf4f-cdff-4338-8ffa-9d04224e2ff2', category: 'curated', tint: '#F5C518', tintLight: '#FFD700', textColor: '#0B0B0B' },
    { slug: 'tmdb-top-rated-series', name: 'Top Rated Series', collectionId: 'cc000000-0000-0000-0000-000000000001', category: 'curated', tint: '#D4A017', tintLight: '#E8B820', textColor: '#0B0B0B' },
    { slug: 'tmdb-trending-movies', name: 'Trending Movies', collectionId: '47117198-8b75-4bca-97f7-a9d3f135dda7', category: 'curated', tint: '#E50914', tintLight: '#FF1A24', textColor: '#ffffff' },
    { slug: 'tmdb-trending-series', name: 'Trending Series', collectionId: 'cc000000-0000-0000-0000-000000000002', category: 'curated', tint: '#C20710', tintLight: '#E50914', textColor: '#ffffff' },
    { slug: 'tmdb-popular-movies', name: 'Popular Movies', collectionId: 'aa000000-0000-0000-0000-00000000000b', category: 'curated', tint: '#01B4E4', tintLight: '#1AC8F5', textColor: '#0B0B0B' },
    { slug: 'tmdb-popular-series', name: 'Popular Series', collectionId: 'cc000000-0000-0000-0000-000000000003', category: 'curated', tint: '#0198C7', tintLight: '#01B4E4', textColor: '#0B0B0B' },
];

const streaming = [
    ['netflix', 'Netflix', '#E50914', '#F6121D', '#ffffff'],
    ['disney', 'Disney+', '#113CCF', '#1A4FFF', '#ffffff'],
    ['hbo', 'HBO Max', '#5822B4', '#6B2FD4', '#ffffff'],
    ['prime', 'Prime Video', '#00A8E1', '#0FBFFF', '#ffffff'],
    ['hulu', 'Hulu', '#1CE783', '#3DFF9E', '#0B0B0B'],
    ['paramount', 'Paramount+', '#0064FF', '#1A7AFF', '#ffffff'],
    ['peacock', 'Peacock', '#1A1A1A', '#333333', '#ffffff'],
    ['crunchyroll', 'Crunchyroll', '#F47521', '#FF8C3D', '#0B0B0B'],
    ['appletv', 'Apple TV', '#555555', '#777777', '#ffffff'],
    ['magellan', 'MagellanTV', '#1C1C1C', '#333333', '#C4A962'],
] ;

const streamingCollections = streaming.flatMap(([key, label, movieTint, light, textColor]) => ([
    { slug: `${key}-movies`, name: `${label} Movies`, tags: providerAliases[key], includeItemType: 'Movie', category: 'streaming', tint: movieTint, tintLight: light, textColor },
    { slug: `${key}-series`, name: `${label} Series`, tags: providerAliases[key], includeItemType: 'Series', category: 'streaming', tint: key === 'netflix' ? '#B20710' : key === 'disney' ? '#0D2FA0' : key === 'hbo' ? '#44198A' : key === 'prime' ? '#0087B5' : key === 'hulu' ? '#14C46E' : key === 'paramount' ? '#0050CC' : key === 'peacock' ? '#000000' : key === 'crunchyroll' ? '#D4620E' : key === 'appletv' ? '#333333' : '#0F0F0F', tintLight: movieTint, textColor },
]));

export const collections = [...curated, ...streamingCollections];
export const curatedCollections = curated;
export const streamingServiceCollections = streamingCollections;
export const getCollection = (slug) => collections.find((collection) => collection.slug === slug);
